import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import { getStudentById, removeStudentById } from "../../actions/student";
import LoaderDots from "../generalComponents/LoaderDots";

import "./StudentProfile.scss";

import StudentFlag from "../generalComponents/StudentFlag";
import { capitalize } from "../../helper/capitalize";
import { dateFormat } from "../../helper/dateConvertor";

const StudentProfile = () => {
  const dispatch = useDispatch();
  const { studentById } = useSelector((state) => state.students);

  const { id } = useParams(); //viene en la url

  useEffect(() => {
    dispatch(getStudentById(id));
    //eslint-disable-next-line
  }, []);

  const handleClickRemoveStudent = () => {
    dispatch(removeStudentById());
  };
  if (!studentById) {
    return <LoaderDots />;
  }

  //Date Formater

  const expirationDate = dateFormat(studentById.visaexpiration);
  const lastMedicalExamDate = dateFormat(studentById.medicalexams);
  const arriveDate = dateFormat(studentById.arriveddate);
  const currenCourseEndDate = dateFormat(studentById.finishingcurrentcourse);
  const plannigComeDate = dateFormat(studentById.planningdate);

  return (
    <div className="app_profile">
      <div className="app_profile__container">
        <div className="profile__heading">
          <h2 className="text-title">Student Profile</h2>
          <NavLink to={`/creator/students`}>
            <button className="btn-primary" onClick={handleClickRemoveStudent}>
              Go Back
            </button>
          </NavLink>
        </div>

        <div className="profile__cards-container">
          <div className="profile-card personal-details">
            <div className="profile-card--content">
              <h2 className="title-gray-black-18 card-content-title">
                Personal Details
              </h2>
              <div className="personal-details__name">
                <h2 className="title-gray-bold-26">{studentById.name}</h2>
                <h2 className="title-gray-reg-26">{studentById.middlename}</h2>
                <h2 className="title-gray-reg-26">{studentById.lastname}</h2>

                {studentById && (
                  <StudentFlag nationality={`${studentById.nationality}`} />
                )}
              </div>
              <div className="personal-details__additionals info-align">
                <p className="paragraph-gray-reg-16">{studentById.status}</p>
                <p className="paragraph-gray-reg-16">
                  {capitalize(studentById.nationality)}
                </p>
                <p className="paragraph-gray-reg-16">
                  {studentById.maritalstatus}
                </p>
                <p className="paragraph-gray-reg-16">{studentById.gender}</p>
              </div>
              <p className="paragraph-gray-reg-16">
                {studentById.comment || "No comments"}
              </p>
            </div>
          </div>

          <div className="profile-card contact-details">
            <div className="profile-card--content">
              <h2 className=" title-gray-black-18 card-content-title">
                Contact Details
              </h2>
              <div className="contact-details__phone info-align">
                <p className="paragraph-gray-reg-16">Phone:</p>
                <p className="paragraph-gray-bold-16 ">
                  {studentById.phone.dial_code}
                </p>
                <p className="paragraph-gray-bold-16 ">
                  {studentById.phone.number}
                </p>
              </div>
              <div className="contact-details__phone info-align">
                <p className="paragraph-gray-reg-16">Email:</p>
                <p className="paragraph-gray-bold-16 ">{studentById.email}</p>
              </div>
              <div className="contact-details__phone info-align">
                <p className="paragraph-gray-reg-16">Current Location:</p>
                <p className="paragraph-gray-bold-16 ">
                  {studentById.currentlocation}
                </p>
              </div>
            </div>
          </div>

          <div className="profile-card visa-details">
            <div className="profile-card--content">
              <h2 className=" title-gray-black-18 card-content-title">
                Visa Details
              </h2>
              <div className="contact-details__visa info-align">
                <p className="paragraph-gray-reg-16">Type:</p>
                <p className="paragraph-gray-bold-16 ">
                  {studentById.visatype || "No data"}
                </p>
              </div>
              <div className="contact-details__visa info-align">
                <p className="paragraph-gray-reg-16">Expiration:</p>
                <p className="paragraph-gray-bold-16 ">
                  {expirationDate || "No data"}
                </p>
              </div>
              <div className="contact-details__visa info-align">
                <p className="paragraph-gray-reg-16">Visa times renewal:</p>
                <p className="paragraph-gray-bold-16 ">
                  {studentById.visatimesrenewal || "No data"}
                </p>
              </div>
              <div className="contact-details__visa info-align">
                <p className="paragraph-gray-reg-16">Last Medical Exams:</p>
                <p className="paragraph-gray-bold-16 ">
                  {lastMedicalExamDate || "No data"}
                </p>
              </div>
            </div>
          </div>
          <div className="profile-card travel-details">
            <div className="profile-card--content">
              <h2 className="title-gray-black-18 card-content-title">
                Travel Details
              </h2>
              <div className="contact-details__travel-details info-align">
                <p className="paragraph-gray-reg-16">Arrive Date:</p>
                <p className="paragraph-gray-bold-16 ">
                  {arriveDate || "No data"}
                </p>
              </div>
              <div className="contact-details__travel-details info-align">
                <p className="paragraph-gray-reg-16">Planning to come Date:</p>
                <p className="paragraph-gray-bold-16 ">
                  {plannigComeDate || "No data"}
                </p>
              </div>
            </div>
          </div>

          <div className="profile-card wellbeing-details">
            <div className="profile-card--content">
              <h2 className="title-gray-black-18 card-content-title">
                Wellbeing
              </h2>
            </div>
          </div>

          <div className="profile-card education-offshore">
            <div className="profile-card--content">
              <h2 className="title-gray-black-18 card-content-title">
                Education offshore
              </h2>

              <div className="contact-details__education-offshore-details info-align">
                <p className="paragraph-gray-reg-16">Courses of Interest:</p>
                <div className="">
                  {studentById.coursesofinterest.length !== 0 ? (
                    studentById.coursesofinterest.map((course, i) => (
                      <p
                        key={`${course}${i}`}
                        className="paragraph-gray-bold-16 courseItem "
                      >
                        {course}
                      </p>
                    ))
                  ) : (
                    <p className="paragraph-gray-bold-16 ">No data</p>
                  )}
                </div>
              </div>

              <div className="contact-details__education-offshore-details info-align">
                <p className="paragraph-gray-reg-16">
                  Courses Finished and in Progress:
                </p>
                <div className="">
                  {studentById.coursesfinished.length !== 0 ? (
                    studentById.coursesfinished?.map((course, i) => (
                      <p
                        key={`${course}${i}`}
                        className="paragraph-gray-bold-16 courseItem "
                      >
                        {course.course}
                        <span>{dateFormat(course.dateinitial)}</span>
                        <span>-</span>
                        <span>{dateFormat(course.datefinished)}</span>
                      </p>
                    ))
                  ) : (
                    <p className="paragraph-gray-bold-16 ">No data</p>
                  )}
                </div>
              </div>

              <div className="contact-details__education-offshore-details info-align">
                <p className="paragraph-gray-reg-16">
                  Highest academic level achieved:
                </p>
                <p className="paragraph-gray-bold-16 ">
                  {studentById.academiclevel || "No data"}
                </p>
              </div>
            </div>
          </div>

          <div className="profile-card education-australia">
            <div className="profile-card--content">
              <h2 className="title-gray-black-18 card-content-title">
                Education in Australia
              </h2>
              <div className="contact-details__education-au-details info-align">
                <p className="paragraph-gray-reg-16">Courses Completed:</p>

                <div>
                  {studentById.coursescompleted.length !== 0 ? (
                    studentById.coursescompleted.map((course, i) => (
                      <p
                        key={`${course}${i}`}
                        className="paragraph-gray-bold-16 courseItem "
                      >
                        {course}
                      </p>
                    ))
                  ) : (
                    <p className="paragraph-gray-bold-16 ">No data</p>
                  )}
                </div>
              </div>
              <div className="contact-details__education-au-details info-align">
                <p className="paragraph-gray-reg-16">Current Course:</p>
                <p className="paragraph-gray-bold-16 ">
                  {studentById.currentcourse || "No data"}
                </p>
              </div>
              <div className="contact-details__education-au-details info-align">
                <p className="paragraph-gray-reg-16">
                  Current Course finishing date:
                </p>
                <p className="paragraph-gray-bold-16 ">
                  {currenCourseEndDate || "No data"}
                </p>
              </div>

              <div className="contact-details__education-au-details info-align">
                <p className="paragraph-gray-reg-16">
                  Course interest the most:
                </p>
                <p className="paragraph-gray-bold-16 ">
                  {studentById.curseofinterestmost || "No data"}
                </p>
              </div>
              <div className="contact-details__education-au-details info-align">
                <p className="paragraph-gray-reg-16">
                  Highest academic level achieved:
                </p>
                <p className="paragraph-gray-bold-16 ">
                  {studentById.highestonshorelevelacademic || "No data"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentProfile;
